// Module
var code = "<p>לחצו בעמוד הבית על &quot;הירשם&quot;, מלאו את כתובת המייל שלכם והסיסמא בה תרצו להשתמש, אשרו את תנאיי השימוש והפרטיות ולחצו &quot;צור חשבון&quot;. אותם פרטים ישמשו אתכם גם כשתחזרו לאתר ותתחברו מחדש.</p> ";
// Exports
export default code;